import easytouse from './../../assets/images/static/FeaturesIcons/easyuse.svg';
import realtime from './../../assets/images/static/FeaturesIcons/rt.svg';
import inventory from './../../assets/images/static/FeaturesIcons/in.svg';
import online from './../../assets/images/static/FeaturesIcons/online.svg';
import cloud from './../../assets/images/static/FeaturesIcons/cloud.svg';
import accessdata from './../../assets/images/static/FeaturesIcons/data.svg';
import qrcode from './../../assets/images/static/FeaturesIcons/Qr.svg';
import support from './../../assets/images/static/FeaturesIcons/cs.svg';

export const featurelist1 = [
  {
    serial: '01',
    class: 'pos',
    source: easytouse,
    details: 'Easy to use POS Solution'
  },
  {
    serial: '03',
    class: 'inventory',
    source: inventory,
    details: 'Inventory Management'
  },
  {
    serial: '05',
    class: 'cloud',
    source: cloud,
    details: 'Cloud Solution'
  },
  {
    serial: '07',
    class: 'qr',
    source: qrcode,
    details: 'QR Code Digital Menu'
  }
]

export const featurelist2 = [
  {
    serial: '02',
    class: 'realtime',
    source: realtime,
    details: 'Real Time Reporting'
  },
  {
    serial: '04',
    class: 'online',
    source: online,
    details: 'Online Ordering'
  },
  {
    serial: '06',
    class: 'data',
    source: accessdata,
    details: 'Access Your Data'
  },
  {
    serial: '08',
    class: 'customer',
    source: support,
    details: 'Customer Support'
  }
]
